import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { CellRenderer, CellRendererParams } from '../../core/interfaces/cell-renderer.interface';
import { DocumentNavigationComponent } from 'app/common/components/document-navigation/document-navigation.component';

/**
 * Delivery Serial Navigation Cell Renderer for DT011 (Entregas/Deliveries)
 *
 * Displays document serial number with navigation capability to Delivery detail page.
 * Shows "Anulada" badge when document status is 0 (cancelled).
 * Document type is hardcoded as DT011 (Entregas).
 *
 * @example
 * ```typescript
 * {
 *   field: 'serials',
 *   headerName: 'Nro. Doc.',
 *   cellRenderer: DeliverySerialNavigationCellRendererComponent,
 *   cellRendererParams: {
 *     documentType: 'DT011'
 *   },
 *   minWidth: 160,
 *   sortable: true,
 * }
 * ```
 */
@Component({
  selector: "app-delivery-serial-navigation-cell-renderer",
  standalone: true,
  imports: [CommonModule, DocumentNavigationComponent, MatChipsModule],
  template: `
    <div class="flex items-center gap-2">
      <app-document-navigation
        [documentType]="documentType"
        [documentSerial]="documentSerial"
        [displayText]="documentSerial"
        [showIcon]="true"
      >
      </app-document-navigation>
      <mat-chip
        *ngIf="isCancelled"
        class="px-2 py-1 text-xs font-medium"
        color="warn">
        Anulada
      </mat-chip>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class DeliverySerialNavigationCellRendererComponent
  implements CellRenderer<any>
{
  @Input() params!: CellRendererParams<any>;

  get documentType(): string {
    return this.params?.cellRendererParams?.documentType ??
           this.params?.data?.documentType ??
           'DT011'; // Delivery document type
  }

  get documentSerial(): string | undefined {
    return this.params?.data?.serials;
  }

  get isCancelled(): boolean {
    return this.params?.data?.statusId === 0;
  }
}
